import { render, staticRenderFns } from "./AdicionalExport.vue?vue&type=template&id=ad433a96"
import script from "./AdicionalExport.vue?vue&type=script&lang=js"
export * from "./AdicionalExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports